module.exports = __webpack_public_path__ + "img/news-2.4ce2d026.jpg";